import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, AddPreferenceRequest, ComplainSearch, Glitch_SearchRequest, ReservationTracesRequest, GuestSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, JobSearch_Compact_Mode } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, ReservationTrace } from '../../Models/ResponseModels';
import { sortBy, chain, filter, uniq } from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UploadImage } from '../UploadImage/UploadImage';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { JobConsole_Compact } from '../JobConsole_Compact/JobConsole_Compact';
import { GlitchConsole_Compact } from '../GlitchConsole_Compact/GlitchConsole_Compact';
import { PreferenceMapping } from '../../Models/GlobalEntities';
import { ExtendedDataKey, ExtendedDataLabels } from '../../enum/ExtendedData';

@Component({
    selector: 'GuestDetail',
    templateUrl: './GuestDetail.html'
})

export class GuestDetail extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('uploadImage') uploadImage: UploadImage;
    @ViewChild('jobConsole_Compact') jobConsole_Compact: JobConsole_Compact;
    @ViewChild('glitchConsole_Compact') glitchConsole_Compact: GlitchConsole_Compact;

    Model: any;
    PropertyId: number;
    GuestId: number;
    TritonReservationId: number;
    PmsReservationId: string;
    AccompanyingGuestIds: number[] = [];

    SelectedNav: number = 0;
    DateFormat: string;
    OnlyDateFormat: string;
    isVisitor: boolean = false;
    guid: any;

    SpecialRequests: Array<PreferenceMapping> = [];

    IsTracesLoading = false;
    ReservationTraces: ReservationTrace[] = [];
    ReservationTracesFiltered: ReservationTrace[] = [];
    TracesPaginationModel: {
        pageSize: number,
        page: number
    };
    lstTraceDepartments: string[];
    SelectedTraceDepartment?: string;

    IsAccompanyingGuestsLoading = false;
    AccompanyingGuests = [];

    @Output() onGuestLoaded: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPreferenceLoaded: EventEmitter<any> = new EventEmitter<any>();
    @Output() onPreferenceDeleted: EventEmitter<any> = new EventEmitter<any>();

    _JobSearch_Compact_Mode = JobSearch_Compact_Mode;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, private complainService: ComplainService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        this.ResetTraces();
        this.ResetAccompanyingGuests();
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
        this.pmsService.GuestImageUpdated.pipe(untilDestroyed(this)).subscribe(value => {
            this.guid = this.generateGuid();
        })
    }

    GuestParams(GuestId: number, TritonReservationId: number, isVisitor: boolean = false) {
        let cGuestId = +this.GuestId;
        this.isVisitor = isVisitor;
        if(this.isVisitor){
            this.SelectedNav = 4;
        }
        this.GuestId = GuestId;
        this.TritonReservationId = TritonReservationId;

        if (GuestId == null) {
            this.Model = null;
            this.SelectedNav = 0;
            this.jobConsole_Compact.Open(null);
            this.glitchConsole_Compact.Open(null);
            return;
        }

        if (cGuestId == this.GuestId) {
            return;
        }

        this.SetData();
    }

    SetModel(data: any): void {
        //console.info(data);
        //this.Model = Model;
        this.Model = null;
        if (data != null) {

            this.GuestId = data.GuestId;
            this.TritonReservationId = data.TritonReservationId;
            this.PmsReservationId = data.PmsReservationId;
            this.PropertyId = data.PropertyId;
            this.AccompanyingGuestIds = data.AccompanyGuest || [];
            this.SetData();
        } else {
            this.AccompanyingGuestIds = [];
        }
    }

    SetData(): void {
        this.ResetTraces();
        this.ResetAccompanyingGuests();
        // set the date part format
        const property = this.masterService.GetProperty(this.PropertyId)
        this.OnlyDateFormat = property && property.PropertyDateFormat.toUpperCase();

        if (this.GuestId == null && this.TritonReservationId == null) {
            this.Model = null;
            this.HandleJobChange();
            this.ShowGlitchHistory();
            this.onGuestLoaded.emit(this.Model);
            return;
        }

        this.IsSubmitting = true;

        this.pmsService.Guest_GetByID(this.GuestId, this.TritonReservationId, true, false)
            .then(data => {
                //console.info(data);
                this.Model = data;
                if (this.SelectedNav == 0) {
                    this.SelectedNav = this.GetDefaultIndex();
                }
                if (this.Model.BirthDay) {
                    this.Model.BirthDay = this.Model.BirthDay.split('T')[0];
                }

                if (this.Model.UpcomingReservation && this.Model.UpcomingReservation.ReservationExtendedData && this.Model.UpcomingReservation.ReservationExtendedData.length > 0) {
                    this.getExtendedDataLabels(this.Model.UpcomingReservation.ReservationExtendedData);
                }

                let requests: Array<string> = [];
                this.SpecialRequests = [];
                if (this.Model.UpcomingReservation && this.Model.UpcomingReservation.SpecialRequests) {
                    requests = this.Model.UpcomingReservation.SpecialRequests.split(',');
                }

                let objProp = this.masterService.Cache_PropertyMainMasters.getValue(this.Model.PropertyId);
                for (let i = 0; i < requests.length; i++) {
                    const special = requests[i] && requests[i].trim();
                    let row = objProp.PreferenceMapping.find(x => x.Code.trim().toUpperCase() == special.toUpperCase());
                    let prefInstance = new PreferenceMapping();
                    if (row) {
                        Object.assign(prefInstance, row)
                        this.SpecialRequests.push(prefInstance);
                    } else if (special) {
                        prefInstance.Code = special.toUpperCase();
                        prefInstance.Descr = '';
                        this.SpecialRequests.push(prefInstance);
                    }

                }

                for (let i = 0; i < this.Model.GuestPreferences.length; i++) {
                    if (!this.IsSystemGuestPreference(this.Model.GuestPreferences[i])) {
                        this.Model.GuestPreferences[i].SystemId = 'PMS';
                    }
                }

                this.IsSubmitting = false;

                if (this.SelectedNav == 3)
                    this.HandleJobChange();

                if (this.SelectedNav == 4)
                    this.ShowGlitchHistory();

                this.onGuestLoaded.emit(this.Model);
            })
            .catch(reason => {
                this.IsSubmitting = false;
            });

        this.SetTraces();
        this.SetAccompanyingGuests();
    }

    // traces --

    SetTraces() {
        this.IsTracesLoading = true;
        this.ReservationTraces = [];
        this.ReservationTracesFiltered = [];
        this.lstTraceDepartments = [];

        const traceSearch = new ReservationTracesRequest();
        traceSearch.PMSReservationId = this.PmsReservationId;
        traceSearch.PropertyId = this.PropertyId;

        this.pmsService.Reservation_GetTraces(traceSearch, false)
            .then(data => {
                this.IsTracesLoading = false;
                if (!data || data.HasError) {
                    return;
                }
                this.ReservationTraces = sortBy(data.Result || [], 'TraceDate').reverse()
                this.FilterTraces(null);
                this.lstTraceDepartments = chain(this.ReservationTraces)
                    .map('TraceDepartment')
                    .compact()
                    .uniq()
                    .value()
                    .sort();

            })
            .catch((reason) => this.IsTracesLoading = false)
    }

    ResetTraces() {
        this.ReservationTraces = [];
        this.ReservationTracesFiltered = [];
        this.lstTraceDepartments = [];
        this.TracesPaginationModel = {
            pageSize: 5,
            page: 1
        }
        this.SelectedTraceDepartment = null;
    }

    FilterTraces(department: string) {
        if (!department) {
            this.ReservationTracesFiltered = this.ReservationTraces.slice();
            return;
        }
        this.ReservationTracesFiltered = filter(this.ReservationTraces, { TraceDepartment : department });

    }

    onTraceDeptChange(newDepartment: string) {
        this.FilterTraces(newDepartment);
    }

    trackTraceByUUID(index: number, item: ReservationTrace) {
        return item.TraceUUID || item.TraceText;
    }

    // --
    // Accompanying Guests

    SetAccompanyingGuests() {
        this.IsAccompanyingGuestsLoading = true;
        this.AccompanyingGuests = [];
        const accompanied = uniq(this.AccompanyingGuestIds || []);
        // send requests for all attached guests
        const requests = (accompanied).map(guestId => {
            const req = new GuestSearch();
            req.GuestId = guestId;
            req.PropertyId = this.PropertyId;
            req.SendReservations = false;
            req.PageNumber = 1;
            req.PageSize = 1;
            return req;
        });

        Promise.all(requests.map(req => this.pmsService.Guest_Search(req, false)))
            .then(responses => {
                this.IsAccompanyingGuestsLoading = false;
                // extract all success response and display those guests
                const successes = responses
                    .filter(resp => resp && !resp.HasError && resp.Result && resp.Result[0])
                    .map(resp => resp.Result[0]);
                this.AccompanyingGuests = successes;
            })
            .catch((reason) => this.IsAccompanyingGuestsLoading = false)
    }

    ResetAccompanyingGuests() {
        this.AccompanyingGuests = [];
    }

    //--


    getExtendedDataLabels(extendedData){
        extendedData.forEach(element => {
            switch(element.DataKey){
                case ExtendedDataKey.ArrivalComments:{
                    element.DataKey = ExtendedDataLabels.ArrivalComments;
                    break;
                }
                case ExtendedDataKey.ArrivalStation:{
                    element.DataKey = ExtendedDataLabels.ArrivalStation;
                    break;
                }
                case ExtendedDataKey.ArrivalStationCode:{
                    element.DataKey = ExtendedDataLabels.ArrivalStationCode;
                    break;
                }
                case ExtendedDataKey.BaggageTag:{
                    element.DataKey = ExtendedDataLabels.BaggageTag;
                    break;
                }
                case ExtendedDataKey.DepartureComments:{
                    element.DataKey = ExtendedDataLabels.DepartureComments;
                    break;
                }
                case ExtendedDataKey.FlightCode:{
                    element.DataKey = ExtendedDataLabels.FlightCode;
                    break;
                }
                case ExtendedDataKey.FlightNumber:{
                    element.DataKey = ExtendedDataLabels.FlightNumber;
                    break;
                }
                case ExtendedDataKey.MarketCode:{
                    element.DataKey = ExtendedDataLabels.MarketCode;
                    break;
                }
                case ExtendedDataKey.RateCode:{
                    element.DataKey = ExtendedDataLabels.RateCode;
                    break;
                }
            }

        });
    }

    HandleJobChange(): void {

        if (this.jobConsole_Compact == null || this.Model == null)
            return;

        if (this.Model != null && this.jobConsole_Compact.RequestModel != null && this.jobConsole_Compact.RequestModel.RequestedByGuestId == this.Model.GuestId) {

        }
        else {
            let req = new ComplainSearch();
            req.RequestedByGuestId = this.Model.GuestId;
            req.Properties = [this.Model.PropertyId]
            req.PageNumber = 1;
            req.PageSize = 15;
            req.OrderBy = "REPORTEDAT";

            this.jobConsole_Compact.Open(req);
        }
    }

    ShowGlitchHistory(): void {
        if (this.glitchConsole_Compact == null || this.Model == null)
            return;

        if (this.Model != null && this.glitchConsole_Compact.RequestModel != null && this.glitchConsole_Compact.RequestModel.Guests.indexOf(this.Model.GuestId) >= 0) {

        }
        else {
            let req = new Glitch_SearchRequest();
            req.Guests = [this.Model.GuestId];
            req.Properties = [this.Model.PropertyId]
            req.PageNumber = 1;
            req.PageSize = 15;
            req.OrderBy = "LastUpdate desc";

            this.glitchConsole_Compact.Open(req);
        }
    }

    ChangeNav(Index: number): void {
         if(!this.isVisitor){
        if (!this.CanChangeNav(Index)) {
            return;
        }
    }
        this.SelectedNav = Index;
        if (this.Model && this.SelectedNav == 3 && this.Model.GuestId != null) {
            this.HandleJobChange();
        }
        else if (this.Model && this.SelectedNav == 4 && this.Model.GuestId != null) {
            this.ShowGlitchHistory();
        }
    }

    CanChangeNav(Index: number): boolean {
        if (!this.Model) {
            return;
        }

        switch (Index) {
            case 1:
                return this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.GuestReservation_Info);
            case 2:
                return this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.GuestProfile_Info);
            case 3:
            case 4:
                return this.CheckAuth_Dept_Action(this.Model.PropertyId, 0, this._AuthActionCodes.GuestHistory_KSV_KG);
            default:
                return false;
        }

    }

    GetDefaultIndex(): number {
        if (this.CanChangeNav(1)) {
            return 1;
        }
        if (this.CanChangeNav(2)) {
            return 2;
        }
        if (this.CanChangeNav(3)) {
            return 3;
        }
    }

    DeletePreference(row: any): void {
        this.pmsService.Guest_DeletePreference(this.GuestId, row.CallDescriptionId).then(data => {
            this.Model.GuestPreferences = data.GuestPreferences;
            this.onPreferenceDeleted.emit();
            this.GetMultilingualToast('TS.TS_PREF_DELETED_SUCCESS', 'success')
        })
    }

    OpenCallRegister(row: any): void {
        let CallData = row;

        CallData.PropertyId = this.Model.PropertyId;
        CallData.TritonReservationId = this.TritonReservationId;
        if (this.Model.CurrentReservations != null && this.Model.CurrentReservations.length > 0) {
            CallData.LocationId = this.Model.CurrentReservations[0].LocationId;
        }
        this.onPreferenceLoaded.emit(CallData);
    }

    onUploadImage() {
        this.uploadImage.Open(this.GuestId,EntityCodes.Guest);
    }

    generateGuid() {
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    IsSystemGuestPreference(guestPreference) {
        if (!guestPreference || !guestPreference.SystemId) {
            return false;
        }
        const systemUpper = guestPreference.SystemId.toUpperCase()
        return systemUpper === 'KNOWCROSS' || systemUpper === 'UNIFOCUS';
    }
}
